import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { View3dService } from 'src/app/shared/services/view3d.service';
import {ApsPresentationView, BgBomModel} from 'src/app/shared/models/bg.model';
import { BackendApiService } from 'src/app/shared/services/backend-api.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-view3d',
  templateUrl: './view3d.component.html',
  styleUrls: ['./view3d.component.scss'],
})
export class View3dComponent {
  @Input() model3dId?: string;

  constructor(
    public view3dService: View3dService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private modelService: BackendApiService ,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.model3dId = params['model3dId'];
    });
  }

  async ngOnInit() {
    this.view3dService.error = undefined;
 
      this.activatedRoute.queryParams.subscribe(async (params) => {
        this.model3dId = params['model3dId'];
        if (params['id']) {
          let data = await firstValueFrom(this.modelService.GetModelById(params['id']));
 
          if (!this.model3dId ) {
            this.view3dService.error = 'Model3dId or selected model is not specified';
            
            return;
          }


          this.view3dService.initViewer(this.authService.getUserToken3d(), this.model3dId, data.result?.apsPresentationViews);

      
        }
      });
    
   

  }
}
